import React from "react";
import PropTypes from "prop-types";
import "./StepIndicator.css";

const StepIndicator = ({ currentStep, totalSteps }) => {
  const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);

  const getConnectorProgress = (stepNumber) => {
    if (stepNumber === currentStep) return 50;
    if (stepNumber < currentStep || currentStep === totalSteps) return 100;
    return 0;
  };

  return (
    <div className="step-indicator-container">
      {steps.map((step, idx) => (
        <div key={step} className="step-wrapper">
          <div
            className={`step ${
              step <= currentStep || currentStep === totalSteps ? "active" : ""
            } ${
              step < currentStep || currentStep === totalSteps
                ? "completed"
                : ""
            }`}
          >
            {step}
          </div>
          {idx < totalSteps - 1 && (
            <div className="connector">
              <div
                className="connector-progress"
                style={{ height: `${getConnectorProgress(step)}%` }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

StepIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default StepIndicator;
